export const API_BASE_URL = window.env?.REACT_APP_API_BASE_URL
  ? window.env.REACT_APP_API_BASE_URL
  : window.location.hostname.includes("localhost")
  ? "http://localhost:3000/"
  : "https://" +
    window.location.hostname.replace(
      /\bstaging-digupno\.grensesnitt\.cloud\b/,
      "staging-digupno-core.grensesnitt.cloud"
    ) +
    // .replace(/\bdigup\.no\b/, "digup-core.no") +
    "/api/";

export const SOCKET_BASE_URL = API_BASE_URL + "core/socket/";
const socket = new URL(SOCKET_BASE_URL);
export const SOCKET_HOSTNAME_URL =
  socket.protocol +
  "//" +
  socket.hostname +
  (socket.port ? ":" + socket.port : "");
export const SOCKET_PATH = socket.pathname + "socket.io/";
